require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./polityka-rachunkowosci.json") })
        }
      }, "path---polityka-rachunkowosci");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---polityka-rachunkowosci!./.cache/json/polityka-rachunkowosci.json
// module id = 522
// module chunks = 231608221292675